// @flow
import React from 'react';
import {Grid, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import CustomButton from '../../../../elements/CustomButton/CustomButton';

type Props = {|
  open: boolean,
  title?: string,
  content?: any,
  handleClose: () => void,
  handleDeleteClick: () => void,
  disabled?: boolean,
|};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: 320,
    // height: 240,
    padding: theme.spacing(4),
  },
  // paper: {
  //   width: 320,
  //   height: 240,
  //   textAlign: 'center',
  //   padding: theme.spacing(4),
  // },
  buttonContainer: {
    marginTop: theme.spacing(2),
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
    '&:disabled': {
      backgroundColor: theme.palette.error.light,
    },
  },
}));

export default function DeleteConfirmationModal(props: Props) {
  const {
    open,
    title,
    content,
    handleClose,
    handleDeleteClick,
    disabled,
  } = props;

  const classes = useStyles();

  const handleConfirm = () => {
    handleClose();
    handleDeleteClick();
  };

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography gutterBottom variant="h6">
          {title}
        </Typography>
        <Typography gutterBottom variant="subtitle1">
          {content}
        </Typography>
        <Grid container className={classes.buttonContainer}>
          <Grid item xs={6}>
            <CustomButton
              variant="contained"
              color="default"
              onClick={handleClose}
            >
              Cancelar
            </CustomButton>
          </Grid>
          <Grid item xs={6}>
            <CustomButton
              variant="contained"
              onClick={handleConfirm}
              className={classes.deleteButton}
              disabled={disabled || false}
            >
              Eliminar
            </CustomButton>
          </Grid>
        </Grid>
      </div>
    </CustomModal>
  );
}
